import { render, staticRenderFns } from "./WorksCard.vue?vue&type=template&id=b0aea070&scoped=true"
import script from "./WorksCard.vue?vue&type=script&lang=js"
export * from "./WorksCard.vue?vue&type=script&lang=js"
import style0 from "./WorksCard.vue?vue&type=style&index=0&id=b0aea070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aea070",
  null
  
)

export default component.exports